"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Form_1 = __importDefault(require("react-bootstrap/Form"));
var react_i18next_1 = require("react-i18next");
var FormFieldCheckInputOption_1 = __importDefault(require("./FormFieldCheckInputOption"));
var FormFieldControl = /** @class */ (function (_super) {
    __extends(FormFieldControl, _super);
    function FormFieldControl(props) {
        return _super.call(this, props) || this;
    }
    FormFieldControl.prototype.getValueFromElement = function (element) {
        var e_1, _a;
        var controlType = this.props.controlType;
        var value = element.value ? element.value : '';
        if (['radio'].includes(controlType)) {
            if (!element.checked) {
                value = undefined;
            }
        }
        else if (['checkbox'].includes(controlType)) {
            value = [];
            var siblings = document.getElementsByName(this.props.fieldName);
            try {
                for (var siblings_1 = __values(siblings), siblings_1_1 = siblings_1.next(); !siblings_1_1.done; siblings_1_1 = siblings_1.next()) {
                    var sibling = siblings_1_1.value;
                    if (sibling.tagName.toUpperCase() === 'INPUT') {
                        if (sibling.checked) {
                            value.push(sibling.getAttribute('value'));
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (siblings_1_1 && !siblings_1_1.done && (_a = siblings_1.return)) _a.call(siblings_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return value;
    };
    FormFieldControl.prototype.onBlur = function (e) {
        var value = this.getValueFromElement(e.target);
        if (this.props.onBlur) {
            this.props.onBlur(this.props.fieldName, value);
        }
    };
    FormFieldControl.prototype.onChange = function (e) {
        var value = this.getValueFromElement(e.target);
        if (this.props.onChange) {
            this.props.onChange(this.props.fieldName, value);
        }
    };
    FormFieldControl.prototype.onUpdateField = function (fieldName, value, inputValue) {
        if (this.props.onChange) {
            this.props.onChange(this.props.fieldName, value, inputValue);
        }
    };
    FormFieldControl.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, fieldName = _a.fieldName, className = _a.className, controlType = _a.controlType, placeholderId = _a.placeholderId, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, invalid = _a.invalid, value = _a.value, loading = _a.loading;
        var placeholder = placeholderId ? t(placeholderId) : undefined;
        var options = undefined;
        var selectedLabel = undefined;
        var selectedValues = Array.isArray(value) ? value : [value];
        if (Array.isArray(this.props.options)) {
            options = this.props.options.map(function (option, index) {
                var optionValue = option;
                var display = option;
                if (Array.isArray(option)) {
                    optionValue = option[0];
                    display = option.length == 1 ? option[0] : option[1];
                    if (value === optionValue)
                        selectedLabel = display;
                    if (['checkbox', 'radio'].includes(controlType)) {
                        return (react_1.default.createElement(Form_1.default.Check, { key: index, id: "formcheck-" + fieldName + "-" + index, inline: true, name: fieldName, label: display, value: optionValue, checked: selectedValues.includes(optionValue), disabled: readOnly, type: controlType, feedback: undefined, onChange: _this.onChange.bind(_this), onBlur: _this.onBlur.bind(_this) }));
                    }
                    else {
                        return (react_1.default.createElement("option", { key: index, value: optionValue }, display));
                    }
                }
                else if (option && option.type) {
                    if (['checkbox', 'radio'].includes(controlType)) {
                        return (react_1.default.createElement(FormFieldCheckInputOption_1.default, __assign({ key: index, id: "formcheck-" + fieldName + "-" + index, controlType: controlType, checked: selectedValues.includes(option.value), fieldName: fieldName, onChange: _this.onUpdateField.bind(_this), onBlur: _this.onUpdateField.bind(_this) }, option)));
                    }
                }
            });
            if (controlType === 'select') {
                options.unshift(react_1.default.createElement("option", { key: 'please_select', value: '' }, t('pleaseSelect')));
            }
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            ['checkbox', 'radio'].includes(controlType) && options,
            !['checkbox', 'radio'].includes(controlType) && !readOnly && !loading && (react_1.default.createElement(Form_1.default.Control, { as: controlType, name: fieldName, className: className, placeholder: placeholder, isInvalid: invalid, value: value, onBlur: this.onBlur.bind(this), onChange: this.onChange.bind(this) }, controlType === 'select' ? options : undefined)),
            !['checkbox', 'radio'].includes(controlType) && !readOnly && loading && (react_1.default.createElement(Form_1.default.Control, { as: controlType, name: fieldName, className: className, placeholder: 'Loading ...', isInvalid: false, disabled: true, value: '' }, controlType === 'select' && react_1.default.createElement("option", { value: '' }, this.props.t('loading')))),
            !['checkbox', 'radio'].includes(controlType) && readOnly && !!selectedLabel && (react_1.default.createElement("span", null, selectedLabel)),
            !['checkbox', 'radio'].includes(controlType) && readOnly && !!!selectedLabel && (react_1.default.createElement("span", null, value))));
    };
    FormFieldControl.propTypes = {
        t: prop_types_1.default.any.isRequired,
        fieldName: prop_types_1.default.string.isRequired,
        fieldNameId: prop_types_1.default.string,
        className: prop_types_1.default.string,
        placeholderId: prop_types_1.default.string,
        controlType: prop_types_1.default.string,
        value: prop_types_1.default.any,
        options: prop_types_1.default.any,
        onBlur: prop_types_1.default.func,
        onChange: prop_types_1.default.func,
        readOnly: prop_types_1.default.bool,
        invalid: prop_types_1.default.bool,
        loading: prop_types_1.default.bool,
        validateRequestId: prop_types_1.default.string, //send unique value to trigger validation
    };
    return FormFieldControl;
}(react_1.default.Component));
exports.default = react_i18next_1.withTranslation()(FormFieldControl);
//# sourceMappingURL=FormFieldControl.js.map